// extracted by mini-css-extract-plugin
module.exports = {"icon":"offer-card_icon__jOEQF","buttonIcon":"offer-card_buttonIcon__muNUo"};